import { inject } from "vue";
const useStrictInject = (injectionSymbol, errorMessage) => {
  const strictInjection = inject(injectionSymbol);
  if (!strictInjection) {
    throw new Error(errorMessage);
  }
  return strictInjection;
};
export {
  useStrictInject as u
};
//# sourceMappingURL=useStrictInject.js.map
